import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import Select2Multiple from 'v-select2-multiple-component';
import CONFIG from "@/assets/js/config.custom.js";

export default {
  name: "refundHistoryDetail",
  components: {
    MainLayout,
    Loading,
    flatPickr,
    Select2Multiple
  },

  data() {
    return {
      isLoading: false,
      currency_txt: '',
      noDataMsg: CONFIG.NO_DATA_FOUND,
      tuitionPaymentId: '',
      refundData: {
        student_name: "",
        academic_year: "",
        class_name: "",
        refund_date: "",
        payment_method: "",
        payment_screenshot: false,
        img_path: "",
        receiver: "",
        remark: "",
        invoice_number: "",
        refund_details: [],
        has_history: false,
        original_invoice_number: "",
        original_payment_id: "",
        student_id: "",
        class_id: "",
      },
    };
  },

  computed: {
    totalRefundAmount() {
      if (!this.refundData.refund_details) return 0;
      return this.refundData.refund_details.reduce((sum, item) => {
        return sum + parseFloat(item.calculated_amount || 0);
      }, 0);
    },
    refundHistoryId() {
      return this.$route.params.id;
    }
  },

  methods: {
    getStudentData(tuitionPaymentId) {
      axios.get(`student/statement/detail/${tuitionPaymentId}`)
        .then(response => {
          const studentInfo = response.data.statement_info;
          if (studentInfo) {
            this.refundData.student_name = studentInfo.student_name || '';
            this.refundData.academic_year = studentInfo.current_academic_period || '';
            this.refundData.class_name = studentInfo.current_class_name || '';
            this.refundData.student_id = studentInfo.student_id || '';
            this.refundData.class_id = studentInfo.class_id || '';
          }
        })
        .catch(error => {
          console.error("Error fetching student data:", error);
        });
    },

    getHistoryInfo() {
      return axios.get(`enrollment/refund/history/${this.refundHistoryId}`)
        .then(res => {
          if (res.data.status === 'success' && res.data.data) {
            const historyInfo = res.data.data;
            this.refundData.refund_date = historyInfo.refund_date;
            this.refundData.payment_method = historyInfo.payment_method;
            this.refundData.remark = historyInfo.remark;
            this.refundData.receiver = historyInfo.receiver;
            this.refundData.invoice_number = historyInfo.invoice_number;
            this.refundData.img_path = historyInfo.img_path;
            this.refundData.payment_screenshot = !!historyInfo.img_path;
            this.refundData.original_invoice_number = historyInfo.original_invoice_number;
            this.refundData.original_payment_id = historyInfo.original_payment_id;
            this.refundData.class_id = historyInfo.class_id;
            this.tuitionPaymentId = historyInfo.tuition_payment_id;
            return {
              refundDate: historyInfo.refund_date,
              tuitionPaymentId: historyInfo.tuition_payment_id
            };
          }
          return null;
        })
        .catch(error => {
          console.error("Error fetching history info:", error);
          return null;
        });
    },

    getDetail(tuitionPaymentId, refundDate = null) {
      this.isLoading = true;
      axios.get(`enrollment/refund/detail/${tuitionPaymentId}`, {
        params: {
          refund_date: refundDate
        }
      })
      .then(res => {
        if (res.data.status === 'success') {
          const data = res.data.data;
          this.refundData.has_history = data.has_history;
          this.refundData.refund_details = data.refund_details || [];
          this.currency_txt = res.data.currency_txt || '';
          this.title = res.data.title || '';
          this.currentActiveTermId = res.data.term_id || '';
        } else {
          this.$notification.error(res.data.message, {
            timer: 3,
            position: "bottomCenter"
          });
          this.back();
          return;
        }
        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
        if (error.response && error.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } else {
          this.$notification.error("Failed to load refund details", {
            timer: 3,
            position: "bottomCenter"
          });
          console.error("Refund Detail API Error:", error);
        }
      });
    },

    pdfDownload() {
      this.isLoading = true;
      const studentName = this.refundData.student_name.replace(/\s+/g, '_');
      axios.get(`/enrollment/refund/pdfDownload/${this.tuitionPaymentId}`, {
          responseType: 'blob',
          headers: {
              'Accept': 'application/pdf'
          }
      })
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        let date = new Date();
        const fileName = `refund_invoice_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth() + 1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        this.isLoading = false;
      }).catch(async (error) => {
        this.isLoading = false;
        if (error.response && error.response.status === 401) {
          this.$store.commit('logout');
          window.location.replace('login');
          return;
        }
        if (error.response && error.response.data instanceof Blob) {
          const text = await error.response.data.text();
          const errorData = JSON.parse(text);
          this.$notification.error(errorData.message || "Failed to download PDF", {
            timer: 3,
            position: "bottomCenter"
          });
        } else {
          this.$notification.error("An unexpected error occurred while downloading the PDF.", {
            timer: 3
          });
        }
      });
    },

    back() {
      this.$router.go(-1);
    },

    openImage(imagePath) {
      window.open(imagePath, '_blank');
    },

    originalPaymentPDFDownload() {
      this.isLoading = true;
      const studentName = this.refundData.student_name.replace(/\s+/g, '_');
      const request = {
        params: {
          campus_id: this.$store.state.user.campus_id,
          payment_id: this.refundData.original_payment_id,
          class_id: this.refundData.class_id,
          is_tuition_pdf: true,
        },
        responseType: 'blob'
      };
      axios.get(`/payment/pdfDownload/${this.refundData.student_id}`, request)
        .then(async (response) => {
          if (response.data.type === 'application/json') {
            const text = await response.data.text();
            const errorData = JSON.parse(text);

            this.$notification.error(errorData.message || "Failed to download invoice PDF", {
              timer: 3,
              position: "bottomCenter"
            });
            this.isLoading = false;
            return;
          }
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          let date = new Date();
          const fileName = `invoice_${studentName}_${date.getFullYear()}${(date.getMonth() + 1) > 9 ? '' : '0'}${date.getMonth() + 1}${(date.getDate()) > 9 ? '' : '0'}${date.getDate()}.pdf`;
          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.error("Invoice PDF download error:", error);
          this.$notification.error("Failed to download invoice PDF", {
            timer: 3,
            position: "bottomCenter"
          });
        });
    },

    goToOriginalPayment() {
      if (this.refundData.original_payment_id) {
        this.$router.push({
          name: 'tuitionPaymentDetail',
          params: {
            tuitionPaymentId: this.tuitionPaymentId,
            studentPaymentId: this.refundData.original_payment_id
          }
        });
      }
    },
  },

  mounted() {
    this.getHistoryInfo().then(result => {
      if (result) {
        this.getStudentData(result.tuitionPaymentId);
        this.getDetail(result.tuitionPaymentId, result.refundDate);
      }
    });
  },
};
